import {
	GenerationStatus,
	ImageGenerationStep,
} from "@prisma/client-generated";
import { z } from "zod";

const status = z.nativeEnum(GenerationStatus);

const zImageGenerationStep = z.nativeEnum(ImageGenerationStep);

const zImageGeneration = z.object({
	id: z.string().uuid(),
	r2Key: z.string().optional().nullable(),
	status,
	createdAt: z.string().or(z.date()),
	stepProgress: z
		.object({
			steps: z.array(zImageGenerationStep),
			currentStep: zImageGenerationStep,
		})
		.optional(),
});

const zVideoGeneration = z.object({
	id: z.string().uuid(),
	r2Key: z.string().optional().nullable(),
	status,
	createdAt: z.string().or(z.date()),
});

const zImageCapture = z.object({
	id: z.string().uuid(),
	r2Key: z.string(),
	createdAt: z.string().or(z.date()),
	imageGeneration: zImageGeneration.optional().nullable(),
	videoGeneration: zVideoGeneration.optional().nullable(),
});

export const zGetImageCaptureRes = z.object({
	items: z.array(zImageCapture),
	nextCursor: z.string().uuid().nullable(),
	hasMore: z.boolean(),
});

export const zPostImageGenerationRes = zImageCapture;

export const zPostVideoGenerationRes = zVideoGeneration;

export const zEnhancementOptions = z.object({
	solarPanels: z.boolean().default(true),
	landscaping: z.boolean().default(true),
	whiteModel: z.boolean().default(false),
	customPrompt: z.string().optional(),
	// Future: facade, vegetation, etc.
});
